import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    month: '',
    fromDate: '',
    toDate: '',
    // Original data (kept for compatibility)
    sales: [],
    production: [],
    ops: [],
    totals: {
        sales: {},
        production: {},
        ops: {},
    },
    // Unified executive report data
    kpiCards: [],
    revenueTrends: {
        daily: [],
        totals: {},
        peakDay: null,
        avgDailyRevenue: 0,
    },
    revenueByLocation: [],
    revenueByPaymentMethod: [],
    orderPipeline: [],
    orderTypeBreakdown: [],
    deliveryPerformance: {},
    productionByLocation: [],
    topTailors: [],
    dailyProduction: [],
    topCustomers: [],
    customerTypeBreakdown: [],
    newCustomersTrend: {},
    stockUsage: [],
    lowStockAlerts: [],
    purchaseSummary: {},
    paymentCollection: {},
    outstandingReceivables: {},
    momComparison: [],

    loading: false,
    error: null,
    settings: null,
    isSettingsInitialized: false,

    filterLoading: false,
    isDefaultFilter: false,
    defaultFilter: {
        id: '',
        name: '',
        identifier: '',
        user_id: '',
        is_shared: false,
        is_readonly: false,
        save_filter: false,
        mark_default: false,
        rules: {
            condition: 'and',
            children: [],
        },
    },
    downloading: false,
    classicFilters: {},
};

const reportmonthlyperformanceSlice = createSlice({
    name: 'reportmonthlyperformance',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        },
        setReportData: (state, action) => {
            const payload = action.payload || {};
            state.month = payload.month || '';
            state.fromDate = payload.from_date || '';
            state.toDate = payload.to_date || '';
            state.sales = payload.sales || [];
            state.production = payload.production || [];
            state.ops = payload.ops || [];
            state.totals = payload.totals || initialState.totals;
            state.loading = false;
            state.error = null;
        },
        setUnifiedReportData: (state, action) => {
            const payload = action.payload || {};
            state.month = payload.month || '';
            state.fromDate = payload.from_date || '';
            state.toDate = payload.to_date || '';
            state.kpiCards = payload.kpi_cards || [];
            state.revenueTrends = payload.revenue_trends || initialState.revenueTrends;
            state.revenueByLocation = payload.revenue_by_location || [];
            state.revenueByPaymentMethod = payload.revenue_by_payment_method || [];
            state.orderPipeline = payload.order_pipeline || [];
            state.orderTypeBreakdown = payload.order_type_breakdown || [];
            state.deliveryPerformance = payload.delivery_performance || {};
            state.productionByLocation = payload.production_by_location || [];
            state.topTailors = payload.top_tailors || [];
            state.dailyProduction = payload.daily_production || [];
            state.topCustomers = payload.top_customers || [];
            state.customerTypeBreakdown = payload.customer_type_breakdown || [];
            state.newCustomersTrend = payload.new_customers_trend || {};
            state.stockUsage = payload.stock_usage || [];
            state.lowStockAlerts = payload.low_stock_alerts || [];
            state.purchaseSummary = payload.purchase_summary || {};
            state.paymentCollection = payload.payment_collection || {};
            state.outstandingReceivables = payload.outstanding_receivables || {};
            state.momComparison = payload.mom_comparison || [];
            state.loading = false;
            state.error = null;
        },
        setSettings: (state, action) => {
            state.settings = action.payload;
            state.isSettingsInitialized = true;
        },
        setDownloading: (state, action) => {
            state.downloading = action.payload;
        },
        setClassicFilters: (state, action) => {
            state.classicFilters = action.payload;
        },
        resetReport: (state) => {
            state.sales = [];
            state.production = [];
            state.ops = [];
            state.totals = initialState.totals;
            state.kpiCards = [];
            state.revenueTrends = initialState.revenueTrends;
            state.revenueByLocation = [];
            state.revenueByPaymentMethod = [];
            state.orderPipeline = [];
            state.orderTypeBreakdown = [];
            state.deliveryPerformance = {};
            state.topTailors = [];
            state.dailyProduction = [];
            state.topCustomers = [];
            state.customerTypeBreakdown = [];
            state.stockUsage = [];
            state.lowStockAlerts = [];
            state.purchaseSummary = {};
            state.paymentCollection = {};
            state.outstandingReceivables = {};
            state.momComparison = [];
            state.month = '';
            state.fromDate = '';
            state.toDate = '';
        },
    },
});

export const {
    setLoading: setReportmonthlyperformanceLoading,
    setError: setReportmonthlyperformanceError,
    setReportData: setReportmonthlyperformanceData,
    setUnifiedReportData: setReportmonthlyperformanceUnifiedData,
    setSettings: setReportmonthlyperformanceSettings,
    setDownloading: setReportmonthlyperformanceDownloading,
    setClassicFilters: setReportmonthlyperformanceClassicFilters,
    resetReport: resetReportmonthlyperformance,
} = reportmonthlyperformanceSlice.actions;

export default reportmonthlyperformanceSlice.reducer;
